export default __webpack_public_path__ + "static/media/calender.d369ba37.svg";